// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__cd7qn","avatarNone":"UserAvatar_avatarNone__1me3_","center":"UserAvatar_center__3he5v"};